import { put, takeEvery, fork, call, select } from 'redux-saga/effects';
import { publish } from '@wh/message-bus';
import { mapSelection } from './utils';
import config from '../../config';
import { noticeError } from '../../utils/noticeError';
import * as constants from '../constants';
import { processingSelectionToBetslip, addToBetslipError } from '../actions';
import { getBetId } from '../../dataProviders';
export const composeMessageBusPayload = (apiResponse) => {
    const { byoSelection, prices } = apiResponse;
    const priceMap = {
        FIXED_ODDS: 'L',
        STARTING_PRICE: 'S',
        DIVIDEND_DECLARATION: 'D',
        REMAINDER_PRICE: 'R',
        PMU: 'P',
        NEXT_PRICE: 'N',
        GUARANTEED_PRICE: 'G',
        BEST_PRICE: 'B',
        FIRST_PRICE: 'F',
        GUARANTEED_PRICE_WITH_REMAINDER_PRICE: 'Q',
        FIRST_SHOW: '1',
        SECOND_SHOW: '2'
    };
    return {
        birIndex: '',
        eventId: config.eventId,
        eventStartTime: '',
        eventType: '',
        ewAvail: 'N',
        ewDenominator: '',
        ewNumerator: '',
        ewPlaces: '',
        handicapValue: 0,
        legSort: '--',
        lpAvail: '',
        tracking: undefined,
        priceDenominator: prices[0].denominator,
        priceNumerator: prices[0].numerator,
        priceType: priceMap[prices[0].type],
        selectionId: byoSelection
    };
};
export function* addToBetslip() {
    try {
        yield put(processingSelectionToBetslip(true));
        // @ts-ignore: Yield error
        const selectionsInSlip = yield select(state => Object.values(state.slip.selections));
        if (selectionsInSlip.length < 2) {
            return;
        }
        if (!config.useBYOFreedom) {
            // @ts-ignore: Yield error
            const response = yield call(getBetId, selectionsInSlip.map((selection) => selection.id));
            const payload = (composeMessageBusPayload(response));
            yield call(publish, 'betslip.leg.add', payload);
            return;
        }
        // @ts-ignore: Yield error
        const payload = yield select(state => ({
            byoEventId: state.markets.data.id,
            byoMarketId: state.slip.byoMarketId,
            byoSelectionDetails: selectionsInSlip.map(mapSelection),
            byoPrice: {
                type: state.slip.prices.type,
                numerator: state.slip.prices.numerator,
                denominator: state.slip.prices.denominator,
            },
        }));
        // @ts-ignore: Yield error
        const editId = yield select(state => state.slip.editId);
        if (editId) {
            yield call(publish, 'wh.sports.betslip.adapter.byo.legs.edit', { id: editId, data: payload });
        }
        else {
            yield call(publish, 'wh.sports.betslip.adapter.byo.legs.add', payload);
        }
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.log('error', error);
        // NewRelic monitoring
        noticeError(error, { errorType: constants.BYO_ERROR_BUILDSLIP });
        yield put(addToBetslipError(error.name));
    }
}
export function* addToBetslipWatcher() {
    yield takeEvery(constants.BYO_ADD_TO_BETSLIP, addToBetslip);
}
const addToBetslipSagas = [fork(addToBetslipWatcher)];
export default addToBetslipSagas;
